module.exports = __webpack_public_path__ + "img/12158f3.png";